import { render, staticRenderFns } from "./ArticleInfoTtsPlayer.vue?vue&type=template&id=3786a0dd&scoped=true"
import script from "./ArticleInfoTtsPlayer.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoTtsPlayer.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoTtsPlayer.vue?vue&type=style&index=0&id=3786a0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3786a0dd",
  null
  
)

export default component.exports